import React from "react";

export default function PortfolioNew({ fill }) {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_4676_36788)">
        <mask id="path-1-inside-1_4676_36788" fill={fill}>
          <path d="M21.7364 15.7611C21.1036 17.4376 20.0406 18.9179 18.6542 20.0532C17.2679 21.1886 15.6071 21.9389 13.8387 22.2288C12.0704 22.5187 10.2569 22.338 8.58065 21.7047C6.90435 21.0715 5.4243 20.0081 4.28933 18.6214C3.15436 17.2348 2.40446 15.5737 2.11503 13.8053C1.8256 12.0369 2.00685 10.2235 2.64054 8.54738C3.27424 6.87125 4.33805 5.3915 5.72501 4.2569C7.11197 3.1223 8.7732 2.37284 10.5417 2.08389L10.9711 4.71202C9.66403 4.92558 8.43623 5.47949 7.41114 6.31806C6.38605 7.15664 5.5998 8.25031 5.13144 9.48912C4.66309 10.7279 4.52913 12.0682 4.74304 13.3752C4.95696 14.6822 5.5112 15.9099 6.35005 16.9347C7.18889 17.9596 8.28278 18.7455 9.52171 19.2136C10.7606 19.6816 12.101 19.8152 13.4079 19.6009C14.7149 19.3867 15.9424 18.8321 16.967 17.993C17.9916 17.1538 18.7773 16.0598 19.245 14.8207L21.7364 15.7611Z" />
        </mask>
        <path
          d="M21.7364 15.7611C21.1036 17.4376 20.0406 18.9179 18.6542 20.0532C17.2679 21.1886 15.6071 21.9389 13.8387 22.2288C12.0704 22.5187 10.2569 22.338 8.58065 21.7047C6.90435 21.0715 5.4243 20.0081 4.28933 18.6214C3.15436 17.2348 2.40446 15.5737 2.11503 13.8053C1.8256 12.0369 2.00685 10.2235 2.64054 8.54738C3.27424 6.87125 4.33805 5.3915 5.72501 4.2569C7.11197 3.1223 8.7732 2.37284 10.5417 2.08389L10.9711 4.71202C9.66403 4.92558 8.43623 5.47949 7.41114 6.31806C6.38605 7.15664 5.5998 8.25031 5.13144 9.48912C4.66309 10.7279 4.52913 12.0682 4.74304 13.3752C4.95696 14.6822 5.5112 15.9099 6.35005 16.9347C7.18889 17.9596 8.28278 18.7455 9.52171 19.2136C10.7606 19.6816 12.101 19.8152 13.4079 19.6009C14.7149 19.3867 15.9424 18.8321 16.967 17.993C17.9916 17.1538 18.7773 16.0598 19.245 14.8207L21.7364 15.7611Z"
          stroke={fill}
          stroke-width="4"
          mask="url(#path-1-inside-1_4676_36788)"
        />
        <mask id="path-2-inside-2_4676_36788" fill={fill}>
          <path d="M12.2169 1.94989C13.7439 1.95444 15.2504 2.30155 16.6254 2.96565C18.0004 3.62975 19.2089 4.59392 20.1618 5.7871L17.9463 7.55649C17.2581 6.69478 16.3853 5.99846 15.3923 5.51885C14.3993 5.03924 13.3113 4.78856 12.2085 4.78527L12.2169 1.94989Z" />
        </mask>
        <path
          d="M12.2169 1.94989C13.7439 1.95444 15.2504 2.30155 16.6254 2.96565C18.0004 3.62975 19.2089 4.59392 20.1618 5.7871L17.9463 7.55649C17.2581 6.69478 16.3853 5.99846 15.3923 5.51885C14.3993 5.03924 13.3113 4.78856 12.2085 4.78527L12.2169 1.94989Z"
          stroke={fill}
          stroke-width="4"
          mask="url(#path-2-inside-2_4676_36788)"
        />
        <mask id="path-3-inside-3_4676_36788" fill={fill}>
          <path d="M21.0996 7.181C22.2465 9.2349 22.6486 11.6219 22.2381 13.9382L19.3891 13.4332C19.6832 11.7736 19.3951 10.0632 18.5734 8.5916L21.0996 7.181Z" />
        </mask>
        <path
          d="M21.0996 7.181C22.2465 9.2349 22.6486 11.6219 22.2381 13.9382L19.3891 13.4332C19.6832 11.7736 19.3951 10.0632 18.5734 8.5916L21.0996 7.181Z"
          stroke={fill}
          stroke-width="4"
          mask="url(#path-3-inside-3_4676_36788)"
        />
      </g>
      <defs>
        <clipPath id="clip0_4676_36788">
          <rect
            width="24"
            height="24"
            fill={fill}
            transform="translate(0.1875 0.441406)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
